import { Utility } from './../../../../shared/utility';
import { ReadConfigService } from './../../../../shared/services/common/read-config.service';
import { DisplayNotificationService } from './../../../../shared/services/common/notification.service';
import { EmployeesService } from './../../../../shared/services/employees/employees.service';
import { UsersService } from './../../../../shared/services/common/users.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ageRangeValidator } from 'src/app/shared/directives/age-validator.directive';

@Component({
  selector: 'app-person-info',
  templateUrl: './person-info.component.html',
  styleUrls: ['./person-info.component.css']
})
export class PersonInfoComponent implements OnInit {
  ssnMask = '000-00-0000';
  ssnPattern = /^(?!666|000\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;
  ssn: number;
  value: any;
  personInfo: any;
  encryptedSSN: any;
  config: any;
  enrollmentInfo: any;
  enrollmentId: Number;
  personalInfoId: Number;
  validSSNMsg: boolean;
  isEmpDetailValid: boolean;
  searchBtnEnable: boolean;
  isPersonInfoVisible: boolean;
  isRecordAlreadyFatched: boolean;
  displayload: boolean;
  isNewPerson: boolean;
  isRetireeInfoVisible: boolean;
  isProcessing = false;
  isNoLegislativeEnrolledSelected = false;
  isLegislativePlan = null;
  personForm: FormGroup;
  defaultItem: { name: string; code: string } = {
    name: 'Select...',
    code: ''
  };
  gendersData = [{ name: 'Male', code: 'M' }, { name: 'Female', code: 'F' }, { name: 'Non-Binary', code: 'X' }];
  speCharPattern = /^[a-zA-Z\s.'\-,`]+$/;

  @Input() set personScreenInfo(wizardData: any) {
    if (wizardData && (wizardData.action === 'edit' ? true : !wizardData.isFinalSubmit)) {
      this.setPersonalInfo((wizardData.action === 'edit' ? wizardData.dataItem : wizardData.wizardData), true, (wizardData.action === 'edit'));
    }
  }

  @Output() goTo = new EventEmitter<object>();
  @Output() formDirtyOrTouched = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private readConfigService: ReadConfigService,
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    this.config = this.readConfigService.getEnrollmentMemberText();
    this.searchBtnEnable = true;
    this.displayload = false;
    this.isProcessing = false;
    this.personInfoForm();
  }

  personInfoForm() {
    this.personForm = this.fb.group({
      id: [Number],
      ssn: [{ value: '', disabled: true }],
      firstName: ['', [Validators.required, Validators.pattern(this.speCharPattern)]],
      MI: [''],
      lastName: ['', [Validators.required, Validators.pattern(this.speCharPattern)]],
      dateOfBirth: ['', [Validators.required, ageRangeValidator()]],
      gender: ['', [Validators.required, this.validateGender.bind(this)]],
    });
  }

  validateGender(control: AbstractControl): { [key: string]: any } | null {
    const valid = this.gendersData.some(option => option.code === control.value);
    return valid ? null : { invalidGender: true };
  }

  setPersonalInfo(data: any, isPreviousInfo: boolean, isEdit: boolean) {
    const personalData = data;
    if (isPreviousInfo) {
      this.value = isEdit ? personalData.ssn : personalData.personDetails.ssn;
      this.ssn = this.value;
      this.employmentInfoSearch(isPreviousInfo, isEdit);
    } else {
      this.isPersonInfoVisible = true;
      this.encryptedSSN = this.encryptedSSN;
      this.enrollmentId = personalData.enrollmentsId;
      if (personalData.personalInfo) {
        setTimeout(() => {
          this.personForm.patchValue({
            id: Number(personalData.personalInfo.id),
            ssn: this.ssn,
            firstName: personalData.personalInfo.firstName.trim(),
            MI: personalData.personalInfo.mi,
            lastName: personalData.personalInfo.lastName.trim(),
            dateOfBirth: new Date(personalData.personalInfo.dateOfBirth),
            gender: personalData.personalInfo.gender
          });
        }, 100);
        if (personalData.personalInfo.isLegislativePlan !== null) {
          const orgId = sessionStorage.getItem('orgId')
          if (orgId === '247') {
            this.isRetireeInfoVisible = true;
            this.isLegislativePlan = personalData.personalInfo.isLegislativePlan;
            this.isNoLegislativeEnrolledSelected = (!personalData.personalInfo.isLegislativePlan);
          } else {
            this.isRetireeInfoVisible = false;
            this.isNoLegislativeEnrolledSelected = true;
          }
        } else {
          this.isRetireeInfoVisible = false;
          this.isNoLegislativeEnrolledSelected = false;
          this.isLegislativePlan = null;
        }
      } else {
        this.searchEmployeeSsn(personalData, true);
      }
    }
  }

  isFormTouched() {
    this.formDirtyOrTouched.emit(this.personForm.dirty || this.personForm.touched);
  }

  selectionChange(value: boolean) {
    this.formDirtyOrTouched.emit(value);
  }

  onSsnChange(input: any) {
    this.isEmpDetailValid = false;
    this.isRecordAlreadyFatched = false;
    this.value = input.trim();
    if (this.value.length > 8) {
      if (this.ssnPattern.test(this.value)) {
        this.searchBtnEnable = false;
        this.validSSNMsg = false;
        this.ssn = this.value;
      } else {
        this.validSSNMsg = true;
        this.searchBtnEnable = true;
      }
    } else {
      this.searchBtnEnable = true;
    }
    this.isPersonInfoVisible = false;
  }

  exitForm() {
    this.value = '';
    this.personForm.reset();
    this.isPersonInfoVisible = false;
    this.displayload = false;
    this.isRetireeInfoVisible = false;
    this.isLegislativePlan = null;
    this.isNoLegislativeEnrolledSelected = false;
    this.formDirtyOrTouched.emit(false);
  }

  employmentInfoSearch(isPreviousInfo: boolean, isEdit: boolean) {
    this.isProcessing = true;
    this.encryptedSSN = this.usersService.encrypt(this.ssn, 'post');
    const inputData = { userInfo: this.usersService.UserInfo(), ssn: this.encryptedSSN };
    this.employeesService.getEmploymentInfo(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.enrollmentInfo = response;
        if (response.enrollmentsId && response.contactInfo && (isEdit ? true : !isPreviousInfo)) {
          this.goToContactInfoScreen(response);
        } else if (response.enrollmentsId && response.scheduleInfo && (isEdit ? true : !isPreviousInfo)) {
          this.goToEnrollmentInfoScreen(response);
        } else {
          this.setPersonalInfo(response, false, false);
        }
        this.isProcessing = false;
        this.searchBtnEnable = true;
      } else {
        this.searchEmployeeSsn(response.personalInfo, true);
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.isProcessing = false;
        this.notificationService.setErrorNotification();
      });
  }

  goToContactInfoScreen(data: any) {
    const enrollmentData = data.scheduleInfo;
    const personData = data.personalInfo;
    const contactData = data.contactInfo;
    personData.ssn = this.ssn;
    this.goTo.emit({
      option: 2, isContactInfo: true, wizardData: {
        personDetails: personData, ssn: this.encryptedSSN, empSSN: Utility.formatSSN(this.ssn),
        enrollmentsId: data.enrollmentsId, enrollmentDetails: enrollmentData, contactDetails: contactData
      }
    });
  }

  goToEnrollmentInfoScreen(data: any) {
    const enrollmentData = data.scheduleInfo;
    const personData = data.personalInfo;
    personData.ssn = this.ssn;
    this.goTo.emit({
      option: 1, isEnrollmentInfo: true, wizardData: {
        personDetails: personData, ssn: this.encryptedSSN, empSSN: Utility.formatSSN(this.ssn),
        enrollmentsId: data.enrollmentsId, enrollmentDetails: enrollmentData
      }
    });
  }

  searchEmployeeSsn(data: any, isNewPerson: boolean) {
    this.isProcessing = true;
    this.displayload = false;
    this.personInfo = {};
    this.enrollmentInfo = null;
    this.isNewPerson = isNewPerson;
    this.encryptedSSN = this.isNewPerson ? this.usersService.encrypt(this.ssn, 'post') : data.ssn;
    const inputData = { userInfo: this.usersService.UserInfo(), ssn: this.encryptedSSN };
    this.employeesService.getPersonInfo(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        if (response.data) {
          this.personInfo = response.data;
          this.enrollmentId = response.enrollmentId;
          this.personForm.patchValue({
            id: this.personInfo.id,
            ssn: this.isNewPerson ? this.ssn : data.personDetails.ssn,
            firstName: this.personInfo.firstName.trim(),
            MI: this.personInfo.mi,
            lastName: this.personInfo.lastName.trim(),
            dateOfBirth: new Date(this.personInfo.dateOfBirth),
            gender: this.isNewPerson ? this.personInfo.sex : data.personDetails.gender
          });
          this.ssn = this.isNewPerson ? this.ssn : data.personDetails.ssn;
          this.isPersonInfoVisible = true;
          if (this.personInfo.isRetiree) {
            const orgId = sessionStorage.getItem('orgId')
            if (orgId === '247') {
              this.isRetireeInfoVisible = true;
              this.isLegislativePlan = null;
              this.isNoLegislativeEnrolledSelected = false;
            } else {
              this.isRetireeInfoVisible = false;
              this.isNoLegislativeEnrolledSelected = true;
            }
          } else {
            this.isRetireeInfoVisible = false;
            this.isNoLegislativeEnrolledSelected = false;
            this.isLegislativePlan = null;
          }
        } else if (response.id > 0) {
          this.isPersonInfoVisible = false;
          this.isRecordAlreadyFatched = true;
        } else {
          this.personForm.patchValue({ ssn: this.ssn });
          this.isPersonInfoVisible = true;
        };
      } else if (response && response.statusCode === 204) {
        this.personForm.reset();
        this.personForm.patchValue({ ssn: this.ssn });
        this.isPersonInfoVisible = true;
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
        this.isPersonInfoVisible = false;
      }
      this.searchBtnEnable = true;
      this.isProcessing = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setErrorNotification();
        this.displayload = false;
        this.isProcessing = false;
        this.searchBtnEnable = false;
        this.isPersonInfoVisible = false;
      });
  }

  onRetireeEnrolledInfoChange() {
    if (this.isLegislativePlan) {
      this.isNoLegislativeEnrolledSelected = false;
    } else {
      this.isNoLegislativeEnrolledSelected = true;
    }
  }

  next(option: number) {
    this.displayload = true;
    const enrollmentData = this.enrollmentInfo?.scheduleInfo;
    const personData = this.enrollmentInfo?.personalInfo;
    const contactData = this.enrollmentInfo?.contactInfo;
    if (this.enrollmentInfo?.scheduleInfo && !this.personForm.dirty) {
      personData.ssn = this.ssn;
      this.goTo.emit({
        option: 1, isEnrollmentInfo: true, wizardData: {
          personDetails: personData, ssn: this.encryptedSSN, empSSN: Utility.formatSSN(this.ssn),
          enrollmentsId: this.enrollmentInfo.enrollmentsId, enrollmentDetails: enrollmentData,
          contactDetails: contactData
        }
      });
      this.displayload = false;
    } else {
      const parsonInfo = {
        Id: this.isNewPerson ? 0 : this.personForm.getRawValue().id, firstName: this.personForm.getRawValue().firstName, mi: this.personForm.getRawValue().MI,
        lastName: this.personForm.getRawValue().lastName, dateOfBirth: Utility.formatDate(this.personForm.getRawValue().dateOfBirth),
        Gender: this.personForm.getRawValue().gender, isLegislativePlan: this.isLegislativePlan, EnrollmentsId: this.enrollmentId ? this.enrollmentId : 0
      }
      const inputData = { userInfo: this.usersService.UserInfo(), ssn: this.encryptedSSN, personalInfo: parsonInfo };
      this.employeesService.savePersonInfo(inputData).subscribe((response: any) => {
        if (response && response.statusCode === 200) {
          this.notificationService.setUpNotification({ message: response.message, success: true });
          this.personForm.addControl('isLegislativePlan', new FormControl(parsonInfo.isLegislativePlan));
          this.goTo.emit({
            option, isEnrollmentInfo: (this.enrollmentInfo?.scheduleInfo ? true : false), wizardData: {
              personDetails: this.personForm.getRawValue(), ssn: this.encryptedSSN, empSSN: Utility.formatSSN(this.ssn),
              enrollmentsId: response.enrollmentsId, enrollmentDetails: enrollmentData, contactDetails: contactData
            }
          });
        } else if (response && response.statusCode === 403) {
          this.router.navigate(['/forbidden']);
        } else {
          this.notificationService.setErrorNotification();
        }
        this.displayload = false;
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.displayload = false;
          this.notificationService.setErrorNotification();
        });
    }
  }

}
